import { render, staticRenderFns } from "./SelecionarGrupo.vue?vue&type=template&id=387d7847&scoped=true&"
import script from "./SelecionarGrupo.vue?vue&type=script&lang=js&"
export * from "./SelecionarGrupo.vue?vue&type=script&lang=js&"
import style0 from "./SelecionarGrupo.vue?vue&type=style&index=0&id=387d7847&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387d7847",
  null
  
)

export default component.exports